export default __webpack_public_path__ + "fed65555d5d135678d7586a1216efb20.png";